import React from 'react';
import { getAlbumStateBadgeClass } from '../../common/ProductUtilities';
import { useTranslation } from 'react-i18next';

const AlbumStateRenderer = (props: any) => {
  const { t } = useTranslation();
  return (
    <div
      className={`badge state-badge ${getAlbumStateBadgeClass(props?.data?.albumState)}`}
    >
      {t(`product.${props?.data?.albumState}`)}
    </div>
  );
};

export default AlbumStateRenderer;
